export default __webpack_public_path__ + "83a2d2b0576c62dc6337ce286d50f982.svg";